module.exports = __webpack_public_path__ + "img/signs6.904bc684.jpg";